export default __webpack_public_path__ + "static/media/TV7.7438c537.png";